import { Panes } from "dev";
import { View } from "react-native";
import { Text } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

import TransactionDetails from "@/src/components/merchant/transaction-details";

export default function ConsumerDeliveryActions() {
  return (
    <Panes numColumns={4}>
      <Example
        text="real production data"
        uuid="46ba325c-9378-4868-99c9-55a551c9782d"
      />
      <Example
        text="before ready for pickup"
        uuid="46ba325c-9378-4868-99c9-55a551c9782d-ready-for-pickup"
      />
      <Example
        text="marked ready for pickup"
        uuid="46ba325c-9378-4868-99c9-55a551c9782d-waiting-for-pickup"
      />
      <Example
        text="picked up (in transit)"
        uuid="46ba325c-9378-4868-99c9-55a551c9782d-in-transit"
      />
    </Panes>
  );
}

function Example({ text, uuid }: { text: string; uuid: string }) {
  const tailwind = useTailwind();
  return (
    <View>
      <Text style={tailwind("text-center m-4")}>{text}</Text>
      <TransactionDetails uuid={uuid} />
    </View>
  );
}
